import React from "react";

function InformationTitle(props){
return(       
    <div className="informations-title">
      <p className="section-title">{props.title}</p>
    </div>
)
}
export default InformationTitle;
